import type { ApprovalRef } from "../api";
import { lazyDialog } from "../../ui";

/** Its own chunk: fetched the first time a review opens. */
const ReviewDialog = lazyDialog(() => import("./ReviewDialog").then((m) => ({ default: m.ReviewDialog })));

/**
 * Where a "To approve" row's Review opens (plan 2D F9 → F10): the review dialog, for change requests and new contacts
 * alike (old-form rows included: they are answered here, never in today's panel). `onLeave`: the review leaves for
 * another page (Edit contact), so the notifications close too.
 */
export const ReviewSlot = ({ reviewRef, onClose, onLeave }: { reviewRef: ApprovalRef | null; onClose: () => void; onLeave?: () => void }) => (
  <ReviewDialog approvalRef={reviewRef} open={reviewRef !== null} onClose={onClose} onLeave={onLeave} />
);
